import { render } from "./ResultMgr.vue?vue&type=template&id=7676dd08&scoped=true"
import script from "./ResultMgr.vue?vue&type=script&lang=js"
export * from "./ResultMgr.vue?vue&type=script&lang=js"

import "./ResultMgr.vue?vue&type=style&index=0&id=7676dd08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7676dd08"]])

export default __exports__